import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  

// 分类获取banner
const state = {
  login: false, // 在线展位图 登录状态 
  tokenData: '', // 用户token
  isRegister: false,   // 当前展会是否注册过
  code: null,    // 二维码信息
  // wxLoginInfo: '', // 扫码登录信息
}
const mutations = {
  setLogin(state, data) {
    localStorage.setItem("login", data);
    state.login = data;
  },
  setTokenData(state, data) {
    state.tokenData = data;
  },
  setRegister(state, bool) { // 设置是否注册
    state.isRegister = bool;
  },
  // setwxLoginInfo(state, data) {
  //   state.wxLoginInfo = data;
  // },
}
const getters = { 
}
const actions = {  
 
  // 收藏相关
  isCollect({ rootState }, id) { // 获取是否收藏
    return new Promise((resolve, reject) => {
      axios.get("/api/collect/compinfo/iscollect/by?compid=" + id, rootState.header).then(doc => {
        if (doc.data.StatusCode === 200) { resolve(doc.data.Data.IsCollect); }
        else { reject(false); }
      });
    });
  },
  addCollect({ rootState }, id) { // 添加收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo", { "CompId": id }, rootState.header).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
  delCollect({ rootState }, id) { // 删除收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo/delete", { "CompId": id }, rootState.header).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
  getMyCollect({ rootState }, req) { // 获取我的收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo/getuser/wherepage", req, rootState.header).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
 
  sendTrack({rootState}, req) { // 详情页发布需求
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Tracking`, req, rootState.header).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  },
  sendRelease({rootState}, req) { // 发布供需
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Release`, req, rootState.header).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  },
  sendReleaseNew({rootState}, req) { // 发布供需
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/NewRealease`, req, rootState.header).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  },

    postCallingadd ({rootState}, req) { // 发布供需
    return new Promise((resolve, reject) => {
        axios.post(`${config.api.reqApi}/api/CallingCard/callingadd`, req, rootState.header).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  },




  getRelease({ rootState }, id) { // 获取供需类别
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/releaseType/GetByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  isProCollect({ rootState }, opt) { // 产品是否关注
    return new Promise((resolve, reject) => {
      axios.get("/api/ProductFollow/hasfollow?userId=" + opt.userId + "&productId=" + opt.productId, rootState.header).then(doc => {
        if (doc.status === 200) { resolve(doc.data); }
        else { reject(false); }
      });
    });
  },
  isChanceCollect({ rootState }, opt) { // 供需是否关注
    return new Promise((resolve, reject) => {
      axios.put("/api/ReleaseFollower/CheckFollow", opt, rootState.header).then(doc => {
        if (doc.status === 200) { resolve(doc.data); }
        else { reject(false); }
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}

